import { Button } from "@mui/material";
import {
  ModalButtonContainer,
  NegativeModalButton,
  PositiveModalButton,
} from "../Button";
import TextContainer from "../Texts/TextContainer";
import React from "react";
import { useModal } from "../modal";
import LoadingButton from "../Button/LoadingButton";
import { UseMutation } from "@reduxjs/toolkit/dist/query/react/buildHooks";

export default function LogOutModal() {
  const { setShow } = useModal();
  //call Api
  const handleLogout = async () => {
    // await adminApi.logout()
    // .then((res) => {
    setShow(false);
    // navigate('/');
    // })
    // .catch(error => {
    // console.log('Logout Error : ', error)
    // })
  };

  return (
    <React.Fragment>
      <TextContainer fontSize="1rem" margin=".5rem 0">
        آیا میخواهید از حساب کاربریتان خارج بشوید؟
      </TextContainer>
      <ModalButtonContainer>
        <Button
          style={NegativeModalButton}
          sx={{
            bgcolor: "primary.main",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "divider",
          }}
          onClick={() => setShow(false)}
        >
          <TextContainer
            fontFamily="'YekanBold !important'"
            fontSize="1rem"
            color="divider"
          >
            خیر، میمانم.
          </TextContainer>
        </Button>
        <Button
          style={PositiveModalButton}
          sx={{
            borderColor: "customColors.purple",
            borderWidth: "1px",
            borderStyle: "solid",
            ":hover": {
              bgcolor: "customColors.purple",
              color: "secondary.main",
            },
          }}
          onClick={handleLogout}
        >
          بله، خارج میشوم.
        </Button>
      </ModalButtonContainer>
    </React.Fragment>
  );
}

type DeleteModalProps = {
  handleDelete?: () => void;
  mutation?: UseMutation<any>;
};
export function DeleteModal({ handleDelete,mutation }: DeleteModalProps) {
  const { setShow } = useModal();
  
  return (
    <React.Fragment>
      <TextContainer fontSize="1rem" margin=".5rem 0">
        آیا مطمینید میخواهید این آیتم را حذف کنید؟
      </TextContainer>
      <ModalButtonContainer>
        <Button
          style={NegativeModalButton}
          sx={{
            color: "divider",
            bgcolor: "primary.main",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "divider",
            ":hover": {
              bgcolor: "divider",
              color: "primary.main",
            },
          }}
          onClick={() => setShow(false)}
        >
          انصراف
        </Button>
        <LoadingButton
          style={PositiveModalButton}
          sx={{
            ":hover": {
              bgcolor: "customColors.purple",
              color: "secondary.main",
            },
          }}
          onClick={handleDelete}
        >
          حذف
        </LoadingButton>
      </ModalButtonContainer>
    </React.Fragment>
  );
}
